module.exports = "/_next/static/images/og-share-default-2dd195c8fdda8a6509171c86cd8767f5.jpg";